<template>
    <v-app-bar app class="elevation-1">
        <v-app-bar-nav-icon @click.stop="setDrawer(!drawer)"></v-app-bar-nav-icon>

        <!-- <img width="140" src="@/assets/Dimitra_logo_white.png" class="mr-12 " /> -->
         <!-- <v-toolbar-title class="ml-2">
           DIMITRA
        </v-toolbar-title> -->

        <v-spacer></v-spacer>

        <template v-if="!isMobile()">
            <!-- <v-btn class="ml-4" icon dark>
                <v-icon class="gray--text">mdi-cog-outline</v-icon>
            </v-btn> -->
            <!-- <div class="text-center">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon dark v-bind="attrs" v-on="on">
                            <v-badge dot color="error" overlap>
                                <v-icon class="gray--text">mdi-bell-outline</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>

                    <v-list subheader three-line>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Example Notification 1</v-list-item-title>
                                <v-list-item-subtitle>Subtext here</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                    </v-list>
                    <v-btn block>clear all notifications</v-btn>
                </v-menu>
            </div> -->
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-list color="transparent">
                        <v-list-item two-line >
                            <v-list-item-avatar>
                                <img :lazy-src="imgURL" :src="imgURL">
                            </v-list-item-avatar>

                            <v-list-item-content class="d-block">
                                <v-list-item-title>{{ currentUser.name }}</v-list-item-title>
                                <v-list-item-subtitle>{{ currentUser.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn icon dark v-bind="attrs" v-on="on">
                                    <v-icon class="gray--text">mdi-chevron-down</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                     </v-list>
                    </template>
                    <v-list>
                        <v-list-item @click="$router.replace({name: 'profile'});">{{ $t('profile') }}</v-list-item>
                        <v-divider></v-divider>
                        <v-list-item @click="logout">
                            {{ $t('logOut') }}
                        </v-list-item>
                    </v-list>
                </v-menu>
        </template>
        <template v-else></template>
        <div class="pt-5">
            <LanguageSelection :pageReload="true"/>
        </div>
    </v-app-bar>
</template>

<script>
import { mapState } from "vuex"
import isMobileMixin from "@/mixins/isMobileMixin"
import LoadingMixin from "@/mixins/LoadingMixin"
import ProfileService from "@/_services/ProfileService";
import axios from "axios";
export default {
    computed: {
        ...mapState(['drawer']),
        currentUser() {
            return this.$store.getters.getUser
        }
    },
    created() {
        this.getProfileData();
    },
    data(){
        return{
            imgURL: '/img/user.jpg'
        }
    },
    methods: {
        setDrawer(val) {
            this.$store.commit('SET_DRAWER', val)
        },
        async logout() {
            this.startLoading();
            await this.$store.dispatch('logout');
            this.stopLoading();
            this.$router.replace({name: 'login'});
        },
        getProfileData() {
            ProfileService.getProfileData()
            .then(async (res) => {
                if (res.success && res.data.imgURL != '' && res.data.imgURL != null) {
                    try{
                        const d = await axios.get(res.data.imgURL)
                        this.imgURL = res.data.imgURL;
                        console.log('image', d)
                    }catch(e) {
                        console.log('image', e)
                        this.imgURL = '/img/user.jpg'
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
        },
    },
    mixins: [isMobileMixin, LoadingMixin]
}
</script>

<style scoped>

</style>